"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _useStyle = _interopRequireDefault(require("./useStyle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DialogContent = function DialogContent(_ref) {
  var titleId = _ref.titleId,
      title = _ref.title,
      onClose = _ref.onClose,
      onCloseLabel = _ref.onCloseLabel,
      description = _ref.description,
      descriptionId = _ref.descriptionId,
      children = _ref.children;
  var cls = (0, _useStyle["default"])();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    component: "header"
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, {
    id: titleId,
    className: cls.title
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    px: 2
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    size: "small",
    "aria-label": onCloseLabel,
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_icons.Close, null)))), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, {
    dividers: true,
    component: "section"
  }, description && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    mb: 2
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    id: descriptionId
  }, description)), children));
};

DialogContent.propTypes = {
  /**
   * Renders directly inside the modal <section /> element
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].node, _propTypes["default"].array]).isRequired,

  /**
   * The title text
   */
  title: _propTypes["default"].string.isRequired,

  /**
   * The description text
   */
  description: _propTypes["default"].string,

  /**
   * Populates the <h2 /> element's ID attribute
   */
  titleId: _propTypes["default"].string.isRequired,

  /**
   * Populates the <p /> element's ID attribute if a description is provided
   */
  descriptionId: _propTypes["default"].string,

  /**
   * Calls this prop when <IconButton /> component is clicked
   */
  onClose: _propTypes["default"].func.isRequired,

  /**
   * The close button's aria label
   */
  onCloseLabel: _propTypes["default"].string
};
DialogContent.defaultProps = {
  description: undefined,
  descriptionId: undefined,
  onCloseLabel: 'Click to close the dialog'
};
var _default = DialogContent;
exports["default"] = _default;